var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAnimals = function SvgAnimals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7A7359",
    strokeLinecap: "round",
    d: "M14.266 17.357a5.24 5.24 0 0 1-7.41-7.41c1.7-1.698 8.237-3.13 10.409-3.567a.48.48 0 0 1 .569.569c-.438 2.172-1.87 8.71-3.568 10.408ZM5 19.293 12.293 12"
  })));
};
export { SvgAnimals as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiPjxwYXRoIHN0cm9rZT0iIzdBNzM1OSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBkPSJNMTQuMjY2IDE3LjM1N2E1LjI0IDUuMjQgMCAwIDEtNy40MS03LjQxYzEuNy0xLjY5OCA4LjIzNy0zLjEzIDEwLjQwOS0zLjU2N2EuNDguNDggMCAwIDEgLjU2OS41NjljLS40MzggMi4xNzItMS44NyA4LjcxLTMuNTY4IDEwLjQwOFpNNSAxOS4yOTMgMTIuMjkzIDEyIi8+PC9zdmc+";